import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { NotificationTemplateModel } from '../../../../../../store/notification-template/model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-template-details',
  templateUrl: './notification-template-details.component.html',
  styleUrls: ['./notification-template-details.component.scss'],
  standalone: false,
})
export class NotificationTemplateDetailsComponent implements OnInit {
  translate = inject(TranslateService);

  @Input('notificationTemplate') public srcNotificationTemplate: NotificationTemplateModel;
  public notificationTemplate: NotificationTemplateModel;
  @Output('onSave') public onSave$ = new EventEmitter<NotificationTemplateModel>();

  popupVisible: boolean;
  toolbarButtonOptions: any = {
    text: this.getShowHTMLText(),
    stylingMode: 'text',
    onClick: () => (this.popupVisible = true),
  };

  ngOnInit(): void {
    this.notificationTemplate = { ...this.srcNotificationTemplate };
  }

  public getShowHTMLText(): string {
    let text;

    this.translate.get('NOTIFICATION_TEMPLATES_BODY').subscribe(value => {
      text = value;
    });

    return text + ' (HTML)';
  }

  public save() {
    this.onSave$.emit(this.notificationTemplate);
  }
}
